/* src/app/shared/components/paginator/paginator.component.css */
.pagination {
  flex-wrap: wrap;
}
.page-item.active .page-link {
  background-color: #8cb7c9;
  border-color: #8cb7c9;
}
/*# sourceMappingURL=paginator.component.css.map */
